import React from 'react';
import { DotsSixVertical } from '@phosphor-icons/react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

export const SortableWidget = ({ id, children, isEditing }) => {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({ id });
  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
    position: 'relative',
  };

  return (
    <div ref={setNodeRef} style={style} className="widget-animate" data-testid={`widget-${id}`}>
      {isEditing && (
        <div
          {...attributes}
          {...listeners}
          data-testid={`widget-drag-handle-${id}`}
          style={{
            position: 'absolute', top: '12px', left: '12px', cursor: 'grab', zIndex: 10,
            padding: '4px', borderRadius: '4px', backgroundColor: 'var(--card-raw, white)',
            display: 'flex', alignItems: 'center', color: 'var(--muted-foreground, #5E5F66)',
            boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
          }}
        >
          <DotsSixVertical size={18} weight="bold" />
        </div>
      )}
      {children}
    </div>
  );
};
